
import { combineReducers } from '@reduxjs/toolkit'
import { userReducer } from './user.slice'
import { dashboardReducer } from './dashboard.slice'
import { settingReducer } from './setting.slice'
import { systemReducer } from './system.slice'
import { reportReducer } from './report.slice'

export const rootReducer = combineReducers({
  user: userReducer,
  dashboard: dashboardReducer,
  setting: settingReducer,
  system: systemReducer,
  report: reportReducer
});
export type RootState = ReturnType<typeof rootReducer>